import { useState as r, useCallback as i } from "react";
const l = (o = 2e3) => {
  const [s, e] = r(!1), t = i(
    (a) => {
      navigator.clipboard.writeText(a), e(!0), setTimeout(() => e(!1), o);
    },
    [o]
  );
  return [s, t];
};
export {
  l as u
};
//# sourceMappingURL=useCopyToClipboard-B_085nfO.js.map
